var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    scopedSlots: _vm._u([
      {
        key: "page-nav",
        fn: function () {
          return [
            _c("ConentNav", {
              attrs: {
                title: "New ",
                iSSelectLang: "",
                cancelBtn: "",
                submitBtn: "",
              },
              on: { submit: _vm.toNew, cancel: _vm.toBack },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-content",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass:
                  "elevation-0 pa-0 transparent ma-auto max-1000 fill-height",
                attrs: { hover: "" },
              },
              [_c("v-card-text", { staticClass: "pa-0 from_content white" })],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }